export const IMAGE_MIMES = {
	png: 'image/png',
	jpg: 'image/jpeg'
};

export async function imageToPdfBytes(file, scale = 1) {
	const { PDFDocument } = await import('pdf-lib');

	const pdfDoc = await PDFDocument.create();

	const imgBytes = await file.arrayBuffer();

	const image =
		file.type === IMAGE_MIMES.png
			? await pdfDoc.embedPng(imgBytes)
			: await pdfDoc.embedJpg(imgBytes);

	const { width, height } = image.scale(scale);

	const page = pdfDoc.addPage([width, height]);

	page.drawImage(image, { x: 0, y: 0, width, height });

	return pdfDoc.save();
}

export function pdfBytesToFile(pdfBytes, name = 'pdfe-file.pdf') {
	return new File([pdfBytes], name, {
		type: 'application/pdf'
	});
}
